import React from 'react';
import { observer } from 'mobx-react';
import ExcelTableTds from './TableTds';
import CardStore from '../../stores/card';
import { getRowIndex } from '../../util/typeUtil';
import ModeExcel from '../../stores/card/ModeExcel';
import ExcelTableColgroupTr from './ColgroupTr';

export interface ExcelTableCellDetailTBodyProps {
    excel?: ModeExcel;
    form: any
    card: CardStore;
    detail?: string;
    isButton?: boolean;
    isNeedPagination: boolean;
    isFixFieldDiv:boolean;
}

@observer
export default class ExcelTableCellDetailTHead extends React.Component<ExcelTableCellDetailTBodyProps, any> {

    renderTableTrs = () => {
        const { excel, card, detail,isFixFieldDiv } = this.props;
        const { edtitleinrow = '0', edtailinrow = '0',  rows = [] } = excel || {};
        let headRow = parseInt(edtitleinrow, 0);
        let bodyRow = parseInt(edtailinrow, 0);
        let _rowhead = rows.slice();
        if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
            return ([[<div>对不起，表头标识、表尾标识设置异常，无法渲染明细！</div>]])
        }
        return excel ? _rowhead.map((row) => {
            const rowIndex: number = getRowIndex(row.id);
            let trs: JSX.Element[] = [];
            if ((rowIndex == (headRow == 2? headRow + 1:headRow)) || rowIndex ==0&&headRow!=1) { //针对行合并处理
                return ;
            } else if (rowIndex < headRow ) {  //只遍历头部信息，合计放在下面
                trs.push(<tr style={{ height: row.size }} >
                    <ExcelTableTds row={getRowIndex(row.id)} card={card} excel={excel} form={card.cubeForm} detail={detail} isFixFieldDiv={isFixFieldDiv}  isTitle={true}/>
                </tr>)
            }
            return trs
        }) : [];
    }
    render() {
        const { excel, isFixFieldDiv} = this.props;
        return (
            <thead>
                <ExcelTableColgroupTr excel={excel} isFixFieldDiv={isFixFieldDiv} />
                {this.renderTableTrs()}
            </thead>
        )
    }
} 


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailTHead.tsx